import {action, makeAutoObservable} from 'mobx';

export const EVENT_LOG_LOGGER_ID: string = "event-logger";

export class LogMessageStore {
    messages: Message[] = [];
    currentMessageId: number;

    constructor() {
        this.currentMessageId = 0;
        (window as any).lms = this;
        makeAutoObservable(this,
                {
                    setMessages: action,
                }
        )
    }

    setMessages(messages: any): void {
        messages.forEach((message: any) => this.upsertMessage(message));
    }

    upsertMessage(json: any): void {
        let message = new Message({id: this.currentMessageId++, ...json}, this);

        if (message.loggerName === "List-" + EVENT_LOG_LOGGER_ID) {
            return;
        }
        this.messages.push(message);
    }

    getMessages(): Message[] {
        return this.messages;
    }

}

export class Message {
    id: string;
    message: string = "";
    color: string = "";
    store: LogMessageStore;
    loggerName?: string;
    content: string;

    constructor(config: any, store: LogMessageStore) {
        makeAutoObservable(this);
        this.store = store;
        this.updateFromJson(config)
    }

    updateFromJson(json: any): void {
        Object.assign(this, json);
    }

}

export default new LogMessageStore();
